export default __webpack_public_path__ + "static/preview-fe1e63c8430140bdb2c940b73f8e3d75.jpg";